module.exports = __webpack_public_path__ + "img/obstacle-puce-alone.e4db58a7.png";